export default {
  root: {
    fontFamily: 'inherit',
  },
};
